
























































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { apiServiceDetail, apiServiceAdd, apiServiceEdit, apiProcessDefinitionList } from '@/api/service'
import { apiWorkOrderTypeLists } from '@/api/work_order'

// 引入富文本编辑器CSS
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

@Component({
  components: {
    quillEditor: require('vue-quill-editor').quillEditor,
    MaterialSelect: require('@/components/material-select/index.vue').default
  }
})
export default class ServiceEdit extends Vue {
    serviceId = ''
    loading = false
    workOrderTypes: any[] = []
    processList: any[] = []

    // 富文本编辑器配置
    editorOptions = {
      theme: 'snow',
      placeholder: '请输入服务详情内容',
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'], // 加粗、斜体、下划线、删除线
          ['blockquote', 'code-block'], // 引用、代码块
          [{ header: 1 }, { header: 2 }], // 标题
          [{ list: 'ordered' }, { list: 'bullet' }], // 有序列表、无序列表
          [{ script: 'sub' }, { script: 'super' }], // 上标/下标
          [{ indent: '-1' }, { indent: '+1' }], // 缩进
          [{ direction: 'rtl' }], // 文本方向
          [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
          [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题级别
          [{ color: [] }, { background: [] }], // 字体颜色、背景色
          [{ font: [] }], // 字体
          [{ align: [] }], // 对齐方式
          ['clean'], // 清除格式
          ['link', 'image', 'video'] // 链接、图片、视频
        ]
      }
    }

    formData: any = {
      service_code: '',
      service_name: '',
      work_order_type_id: '',
      process_definition_id: '',
      cover_image: '',
      description: '',
      content: '',
      duration_type: 1, // 时长类型：1-小时，2-天
      duration_hours: 1.0,
      duration_days: 1,
      base_price: 0,
      deposit_rate: 0,
      warranty_days: 0,
      checkin_type: 0, // 打卡类型：0-一次性打卡，1-每天打卡
      apply_scene: [],
      service_tags: [],
      sort: 255,
      status: true
    }

    rules = {
      service_code: [
        { required: true, message: '请输入服务编码', trigger: 'blur' },
        { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
      ],
      service_name: [
        { required: true, message: '请输入服务名称', trigger: 'blur' },
        { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
      ],
      work_order_type_id: [
        { required: true, message: '请选择服务类型', trigger: 'change' }
      ],
      process_definition_id: [
        { required: false, message: '请选择关联流程', trigger: 'change' }
      ],
      base_price: [
        { required: true, message: '请输入基础价格', trigger: 'blur' },
        { type: 'number', min: 0, message: '价格不能小于0', trigger: 'blur' }
      ],
      deposit_rate: [
        { required: true, message: '请输入定金比例', trigger: 'blur' },
        { type: 'number', min: 0, max: 100, message: '范围为 0～100', trigger: 'blur' }
      ]
    }

    applySceneOptions = [
      '日常保洁',
      '深度清洁',
      '退房保洁',
      '开荒保洁',
      '家电维修',
      '水电维修',
      '安防巡检',
      '安全检查',
      '设备维护',
      '其他服务'
    ]

    serviceTagOptions = [
      '快速响应',
      '专业团队',
      '环保材料',
      '持证上岗',
      '原厂配件',
      '上门服务',
      '质保服务',
      '价格透明',
      '24小时服务',
      '免费咨询'
    ]

    get pageTitle (): string {
      return this.serviceId ? '编辑服务' : '添加服务'
    }

    getWorkOrderTypes (): void {
      apiWorkOrderTypeLists({ page: 1, size: 10 })
        .then((res: any) => {
          this.workOrderTypes = res.lists || []
        })
    }

    getServiceDetail (): void {
      if (!this.serviceId) return
      apiServiceDetail({ id: this.serviceId })
        .then((res: any) => {
          if (res) {
            // 排除后端自动维护的字段
            const { create_time, update_time, ...restData } = res

            this.formData = {
              ...this.formData,
              ...restData,
              // 确保duration_type字段存在
              duration_type: res.duration_type || 1,
              // 确保时长字段存在
              duration_hours: res.duration_hours || 1.0,
              duration_days: res.duration_days || 1,
              deposit_rate: res.deposit_rate != null && res.deposit_rate !== '' ? Number(res.deposit_rate) : 0,
              // 确保打卡类型字段存在
              checkin_type: res.checkin_type || 0,
              // 处理数组字段
              apply_scene: Array.isArray(res.apply_scene) ? res.apply_scene
                : (res.apply_scene_text ? res.apply_scene_text.split(',') : []),
              service_tags: Array.isArray(res.service_tags) ? res.service_tags
                : (res.service_tags_text ? res.service_tags_text.split(',') : [])
            }
          }
        })
    }

    // 富文本编辑器事件处理
    onEditorBlur (editor: any) {
      console.log('编辑器失去焦点', editor)
    }

    onEditorFocus (editor: any) {
      console.log('编辑器获得焦点', editor)
    }

    onEditorReady (editor: any) {
      console.log('编辑器准备就绪', editor)
    }

    handleSubmit (): void {
      (this.$refs.form as any).validate((valid: boolean) => {
        if (!valid) {
          return false
        }

        this.loading = true

        // 构建提交数据，只包含必要的字段
        const submitData = {
          // 基本信息
          service_code: this.formData.service_code,
          service_name: this.formData.service_name,
          work_order_type_id: Number(this.formData.work_order_type_id),
          process_definition_id: this.formData.process_definition_id || '',

          // 图片和描述
          cover_image: this.formData.cover_image || '',
          description: this.formData.description || '',
          content: this.formData.content || '',

          // 价格和时长
          duration_type: Number(this.formData.duration_type),
          duration_hours: this.formData.duration_type === 1 ? Number(this.formData.duration_hours) : 0,
          duration_days: this.formData.duration_type === 2 ? Number(this.formData.duration_days) : 0,
          base_price: Number(this.formData.base_price),
          deposit_rate: Number(this.formData.deposit_rate),

          // 其他设置
          warranty_days: Number(this.formData.warranty_days),
          checkin_type: Number(this.formData.checkin_type),

          // 标签和场景
          apply_scene: Array.isArray(this.formData.apply_scene) ? this.formData.apply_scene : [],
          service_tags: Array.isArray(this.formData.service_tags) ? this.formData.service_tags : [],

          // 排序和状态
          sort: Number(this.formData.sort),
          status: this.formData.status ? 1 : 0
        }

        // 编辑和新增使用不同的API参数
        let apiParams: any
        if (this.serviceId) {
          // 编辑时，只传递需要更新的字段
          apiParams = {
            id: this.serviceId,
            ...submitData
          }
        } else {
          // 新增时传递所有字段
          apiParams = submitData
        }

        const apiFunc = this.serviceId ? apiServiceEdit : apiServiceAdd

        apiFunc(apiParams)
          .then(() => {
            this.handleCancel()
          })
          .finally(() => {
            this.loading = false
          })
      })
    }

    handleCancel (): void {
      this.$router.go(-1)
    }

    // 获取流程列表
    async getProcessList () {
      try {
        const res = await apiProcessDefinitionList({ status: 1 }) // 只获取启用的流程
        console.log('res', res)
        if (res) {
          this.processList = res.lists || []
        }
      } catch (error) {
        console.error('获取流程列表失败:', error)
      }
    }

    // 生成随机服务编码
    generateServiceCode () {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      let result = ''
      const length = 10 // 生成10位编码，确保在20字符以内

      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length))
      }

      this.formData.service_code = result
    }

    created () {
      this.serviceId = this.$route.query.id as string || ''
      this.getWorkOrderTypes()
      this.getProcessList()
      this.getServiceDetail()
    }
}
